module.exports = __webpack_public_path__ + "img/null_data.67ab4218.png";